const validatePropertyDatatype = (propertyValues, propertyName) => {
  propertyValues.forEach((element) => {
    if (typeof element !== "number") {
      throw new Error("Non-number element found in properties [" + propertyName + "]: " + element);
    }
  });
};

const getPercentiles = (geojson, propertyName, low, high) => {
  // Find the values that are at the low and high percentiles of the property "propertyName" in geojson data.
  // The zero-values and the smallest nonzero value are ignored.

  const fallBack = { lowValue: 0.5, highValue: 1, smallestNonzeroValue: 0.25 };
  if (geojson.features.length === 0) {
    return fallBack;
  } // No values, so we return some default values

  if (!(propertyName in geojson.features[0].properties)) {
    throw new Error(
      "The geojson does not have a property called " +
        propertyName +
        " only " +
        Object.keys(geojson.features[0].properties).join(", ") +
        " are available",
    );
  }
  const valuesArray = geojson.features.map((feature) => feature.properties[propertyName]);
  validatePropertyDatatype(valuesArray, propertyName);

  const uniqueArray = [...new Set(valuesArray)]; // Make array contain only unique values
  let sorted = uniqueArray.sort((a, b) => a - b); // Numerically sort the array

  sorted = sorted.filter((value) => value !== 0); // Remove all zero values
  if (sorted.length === 0) return fallBack;

  let smallestNonzeroValue = sorted[0];
  sorted.shift(); // Remove the first element

  if (sorted.length === 0) {
    return {
      lowValue: smallestNonzeroValue + 0.2,
      highValue: smallestNonzeroValue + 1,
      smallestNonzeroValue,
    };
  }

  const targetHighIndex = Math.max(Math.floor(sorted.length * high) - 1, 0);
  const targetLowIndex = Math.max(Math.floor(sorted.length * low) - 1, 0);

  let highValue = sorted[targetHighIndex];
  let lowValue = sorted[targetLowIndex];

  if (lowValue === highValue) {
    // If all values are the same, the color scale will not work, so we need to make them different
    highValue = lowValue + 1;
  }
  return { lowValue, highValue, smallestNonzeroValue };
};

const lowerBoundary = 0.1;
// approximately 10% of the unique nonzero values will be below this boundary
const higherBoundary = 0.8;
// approximately 20% of the unique nonzero values will be above this boundary

export const getListOfLevels = (json, geojson) => {
  // Example:
  // {0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 9, 9, 9, 9,10} => boundaries [2 8] => 3 levels { 2, 5, 8 }
  const limits = getPercentiles(geojson, json.propertyName, lowerBoundary, higherBoundary);

  const legendLevels = json.colorList.map((color, i) => {
    const level = limits.lowValue + ((limits.highValue - limits.lowValue) / (json.colorList.length - 1)) * i;
    return { level, color };
  });
  // Linear interpolation of colors will apply between these levels.

  if (legendLevels[0].level <= limits.smallestNonzeroValue) {
    throw new Error(
      "The first level " +
        legendLevels[0].level +
        " should be higher than the smallest nonzero value " +
        limits.smallestNonzeroValue,
    );
  }
  for (let i = 0; i < legendLevels.length; i++) {
    if (i > 0) {
      if (legendLevels[i].level <= legendLevels[i - 1].level) {
        throw new Error(
          "The levels should be increasing, but " +
            legendLevels[i].level +
            " is not higher than " +
            legendLevels[i - 1].level,
        );
      }
    }
  }
  return { legendLevels, limits };
};
